/**
 *  @class
 *  @function MaxHeight
 */
if (!customElements.get('max-height')) {
  class MaxHeight extends HTMLElement {
    constructor() {
      super();
      this.content = this.querySelector('.max-height--inner-content');
      this.toggle = this.querySelector('.max-height--toggle');
      this.max = this.dataset.max;
      this.maxMobile = this.dataset.maxMobile;
    }

    connectedCallback() {
      this.toggle.addEventListener('click', this.onClick.bind(this));
      window.addEventListener('resize', this.checkVisible.bind(this));

      this.checkVisible();
    }

    checkVisible() {
      const maxHeight = window.innerWidth <= 767 ? this.maxMobile : this.max;
      if (this.content.offsetHeight > maxHeight) {
        this.showToggle();
      } else {
        this.hideToggle();
      }
    }

    showToggle() {
      this.classList.add('max-height--active');
    }

    hideToggle() {
      this.classList.remove('max-height--active');
    }

    onClick() {
      this.classList.toggle('max-height--enabled');
    }
  }

  customElements.define('max-height', MaxHeight);
}